import { render, staticRenderFns } from "./AsterContacts.vue?vue&type=template&id=add72d78"
import script from "./AsterContacts.vue?vue&type=script&lang=js"
export * from "./AsterContacts.vue?vue&type=script&lang=js"
import style0 from "./AsterContacts.vue?vue&type=style&index=0&id=add72d78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports